import { render, staticRenderFns } from "./StaticRoutesList.vue?vue&type=template&id=2c5c34ba&scoped=true&"
import script from "./StaticRoutesList.vue?vue&type=script&lang=ts&"
export * from "./StaticRoutesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5c34ba",
  null
  
)

export default component.exports